import React from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import localizedFormat from 'dayjs/plugin/localizedFormat';

import 'shims';
import 'importMinimalAssets';

import i18n from './i18n/i18n';
import store from './store/store';
import { App } from './App';

dayjs.extend(localizedFormat);
dayjs.extend(isSameOrBefore);

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);
  root.render(
    <I18nextProvider defaultNS="translation" i18n={i18n}>
      <Provider store={store}>
        <App />
      </Provider>
    </I18nextProvider>,
  );
}
